/**
 * Mirrors legacy Ask by observing the editor root's native paste event while TextPlugin retains
 * ownership of the shared Lexical paste command.
 */
export function makeRegisterPasteHandler(editor) {
    return (handler) => editor.registerRootListener((rootElement, previousRootElement) => {
        previousRootElement?.removeEventListener('paste', handler);
        rootElement?.addEventListener('paste', handler);
    });
}
//# sourceMappingURL=registerPasteHandler.js.map